function Avatar({ src }) {
  return (
    <div className="avatar-container">
      <img
        src={src}
        alt="Profile"
        className="avtar-image"
      />
    </div>
  );
}

export default Avatar;
